// Copyright (c) Ping. All rights reserved.

import type React from 'react';

import { PollComposerOverlay, type PollComposerScreenSubmitPayload } from '@ping/ui';

import type { ChatHostProps } from './types';

/**
 * invite-flow Wave 2 — web orchestrator for the shared
 * `PollComposerOverlay`.
 *
 * Open/close state + modal chrome live in the shared overlay. This
 * host only forwards the web-side `onSubmitDraft` callback (synthesis
 * wires this into the live `MessagingClient.send` path through the
 * existing `ChatRoom` text-send pipeline). The composer itself never
 * touches the SDK.
 */
export interface PollComposerHostProps extends ChatHostProps {
  readonly onSubmitDraft: (payload: PollComposerScreenSubmitPayload) => Promise<void> | void;
}

export const PollComposerHost: React.FC<PollComposerHostProps> = ({ vm, onSubmitDraft }) => (
  <PollComposerOverlay vm={vm} onSubmitDraft={onSubmitDraft} />
);
